export const AUTH_BASE_URL =
  import.meta.env.VITE_APP_ENV === 'staging'
    ? 'https://auth.webcatalog.dev'
    : import.meta.env.VITE_APP_ENV === 'local'
      ? 'http://localhost:5201'
      : 'https://auth.webcatalog.io';
